import { MenuItem, TableCell, TableRow } from "@mui/material";
import { AxiosResponse } from "axios";
import BrotherPrint from "Pages/Printing/BrotherPrint";
import { DymoMultiPrint } from "Pages/Printing/DymoMultiPrint";
import { ZebraMultiPrint } from "Pages/Printing/ZebraMultiPrint";
import { getPrinterContentData } from "Pages/Printing/getPrinterContentData";
import { NormalizedData } from "Pages/Requisition/SingleRequisition/ViewReq/Row";
import React, { useState } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Approve,
  BulkReRunPGxLISOrders,
  BulkReSendPGxLISOrders,
  UnApprove,
} from "Services/PGXLis/Interpretation";
import RequisitionType from "Services/Requisition/RequisitionTypeService";
import Status from "Shared/Common/Status";
import useLang from "Shared/hooks/useLanguage";
import ArrowBottomIcon from "Shared/SVG/ArrowBottomIcon";
import { StyledDropButton, StyledDropMenu } from "Utils/Style/Dropdownstyle";
import { savePdfUrls } from "../../../Redux/Actions/Index";
import PermissionComponent, {
  getPermissionDisplayName,
} from "../../../Shared/Common/Permissions/PermissionComponent";
import {
  formatViewRequisitionLabTime,
  isIntegrationOrder,
} from "../../../Utils/Common/LabTimeZone";
import { dateFormatConversion } from "../../../Utils/Common/viewRequisitiontabs";
import {
  SelectedBoxI,
  useInterpretationContext,
} from "./InterpretationContext";
import RejectModal from "./RejectModal";

const Row = (props: any) => {
  const { t } = useLang();

  const { selectedBox, setSelectedBox, filterData, data, loadGridData } =
    useInterpretationContext();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState({
    dropdown1: null,
    dropdown2: null,
    dropdown3: null,
    dropdown4: null,
  });

  const handleClick = (event: any, dropdownName: string) => {
    setAnchorEl({ ...anchorEl, [dropdownName]: event.currentTarget });
  };

  const handleClose = (dropdownName: string) => {
    setAnchorEl({ ...anchorEl, [dropdownName]: null });
  };

  const PrintLabel = async (option: any, printerId: number) => {
    const objToSend = {
      printerId: printerId,
      contentList: [
        {
          requisitionOrderId: NormalizedData(
            props?.RowData,
            "requisitionorderid"
          ),
          requisitionId: props?.RowData?.RequisitionId,
        },
      ],
    };

    const content = await getPrinterContentData(objToSend);
    if (!content) return;
    if (option?.includes("zebra") || option?.includes("Zebra")) {
      ZebraMultiPrint(content);
      handleClose("dropdown4");
      return;
    }
    if (option.includes("dymo") || option.includes("Dymo")) {
      DymoMultiPrint(content);
      handleClose("dropdown4");
      return;
    }
    if (option.includes("brother") || option.includes("Brother")) {
      BrotherPrint(content);
      handleClose("dropdown4");
      return;
    } else {
      toast.error("Configuration not available");
      return;
    }
  };

  const openDrop =
    Boolean(anchorEl.dropdown1) ||
    Boolean(anchorEl.dropdown2) ||
    Boolean(anchorEl.dropdown3) ||
    Boolean(anchorEl.dropdown4);

  const handleSelectedResultDataIds = (
    checked: boolean,
    requisitionId: number,
    requisitionOrderId: number
  ) => {
    setSelectedBox((prev: SelectedBoxI) => ({
      ...prev,
      ids: checked
        ? [...prev.ids, { requisitionOrderId, requisitionId }]
        : prev.ids.filter(
            (item) => item.requisitionOrderId !== requisitionOrderId
          ),
    }));
  };

  const openInNewTab = (url: any) => {
    window.open(url, "_blank", "noreferrer");
  };

  const approveMutation = useMutation({
    mutationFn: async () => {
      const payload = {
        requisitionId: NormalizedData(props?.RowData, "requisitionid"),
        requisitionOrderId: NormalizedData(
          props?.RowData,
          "requisitionorderid"
        ),
      };
      const res = await Approve([payload]);
      return res;
    },

    onSuccess: (res) => {
      if (res?.data?.statusCode === 200) {
        setSelectedBox({ ids: [] });
        loadGridData(true);
        toast.success(t(res?.data?.message));
      } else {
        toast.error(t(res?.data?.message));
      }
    },

    onError: (error: any) => {
      console.error(error, "bulk request failure");
      toast.error("Request failed");
    },
  });

  const unApproveMutation = useMutation({
    mutationFn: async () => {
      const res = await UnApprove([
        NormalizedData(props?.RowData, "requisitionorderid"),
      ]);
      return res;
    },

    onSuccess: (res) => {
      if (res?.data?.statusCode === 200) {
        setSelectedBox({ ids: [] });
        loadGridData(true);
        toast.success(t(res?.data?.message));
      } else {
        toast.error(t(res?.data?.message));
      }
    },

    onError: (error: any) => {
      console.error(error, "bulk request failure");
      toast.error("Request failed");
    },
  });

  const rerunMutation = useMutation({
    mutationFn: async () => {
      const res = await BulkReRunPGxLISOrders([
        NormalizedData(props?.RowData, "requisitionorderid"),
      ]);
      return res;
    },

    onSuccess: (res) => {
      if (res?.data?.statusCode === 200) {
        setSelectedBox({ ids: [] });
        loadGridData(true);
        toast.success(t(res?.data?.message));
      } else {
        toast.error(t(res?.data?.message));
      }
    },

    onError: (error: any) => {
      console.error(error, "rerun request failure");
      toast.error("Request failed");
    },
  });

  const resendMutation = useMutation({
    mutationFn: async () => {
      const res = await BulkReSendPGxLISOrders([
        NormalizedData(props?.RowData, "requisitionorderid"),
      ]);
      return res;
    },

    onSuccess: (res) => {
      if (res?.data?.statusCode === 200) {
        setSelectedBox({ ids: [] });
        loadGridData(true);
        toast.success(t(res?.data?.message));
      } else {
        toast.error(t(res?.data?.message));
      }
    },

    onError: (error: any) => {
      console.error(error, "resend request failure");
      toast.error("Request failed");
    },
  });

  const useRestoreRequisition = () => {
    return useMutation({
      mutationFn: async (id: number) => {
        const res: AxiosResponse = await RequisitionType.RestoreRequisition(id);
        return res;
      },
      onSuccess: (res) => {
        if (res?.data?.httpStatusCode === 200) {
          toast.success(res.data.message);
          loadGridData(true);
        } else {
          toast.error(res.data.message);
        }
      },
      onError: (err) => {
        console.error(err);
      },
    });
  };

  const { mutate: restoreRequisition } = useRestoreRequisition();

  return (
    <>
      <RejectModal
        show={show}
        setShow={setShow}
        loadGridData={loadGridData}
        setSelectedBox={setSelectedBox}
        selectedRecord={[NormalizedData(props?.RowData, "requisitionorderid")]}
      />
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        {filterData?.tabId === 3 ? null : (
          <TableCell
            id={`BloodResultDataCheckBox_${NormalizedData(props?.RowData, "requisitionorderid")}`}
            style={{ width: "49px" }}
          >
            <label className="form-check form-check-sm form-check-solid d-flex justify-content-center">
              <input
                id={`BloodResultDataCheckBox_${NormalizedData(props?.RowData, "requisitionorderid")}`}
                className="form-check-input"
                type="checkbox"
                checked={
                  !!selectedBox?.ids?.some(
                    (item) =>
                      item.requisitionOrderId ===
                      NormalizedData(props?.RowData, "requisitionorderid")
                  )
                }
                onChange={(e) =>
                  handleSelectedResultDataIds(
                    e.target.checked,
                    NormalizedData(props?.RowData, "requisitionid"),
                    NormalizedData(props?.RowData, "requisitionorderid")
                  )
                }
              />
            </label>
          </TableCell>
        )}
        <TableCell
          id={`Requisition3Dots_${NormalizedData(
            props?.RowData,
            "requisitionorderid"
          )}`}
          className="min-w-50px w-50px"
        >
          <div className="d-flex justify-content-center rotatebtnn">
            <DropdownButton
              className="p-0 del-before btn btn-light-info btn-active-info btn-sm btn-action table-action-btn"
              key="end"
              id="ViewRequisition3Dots"
              drop="end"
              title={<i className="bi bi-three-dots-vertical p-0"></i>}
            >
              {filterData.tabId === 1 ? (
                <>
                  <PermissionComponent
                    moduleName="PGX LIS"
                    pageName="Interpretation"
                    permissionIdentifier="View"
                  >
                    {({ pageName, moduleName, permissionIdentifier }) => (
                      <Dropdown.Item
                        id="RequisitionView"
                        eventKey="2"
                        onClick={() => {
                          const tokenData: any =
                            sessionStorage.getItem("userinfo");
                          localStorage.setItem("userinfo", tokenData);
                          openInNewTab(
                            `/OrderView/${btoa(
                              NormalizedData(props?.RowData, "requisitionid")
                            )}/${btoa(
                              NormalizedData(
                                props?.RowData,
                                "requisitionorderid"
                              )
                            )}`
                          );
                        }}
                      >
                        <button
                          role="link"
                          className="px-0 border-0 bg-transparent "
                        >
                          <i className="fa fa-eye text-success mr-2 w-20px"></i>
                          {getPermissionDisplayName(
                            pageName,
                            moduleName,
                            permissionIdentifier,
                            "View"
                          )}
                        </button>
                      </Dropdown.Item>
                    )}
                  </PermissionComponent>
                  <PermissionComponent
                    moduleName="PGX LIS"
                    pageName="Interpretation"
                    permissionIdentifier="Edit"
                  >
                    {({ pageName, moduleName, permissionIdentifier }) => (
                      <Dropdown.Item
                        id="RequisitionEdit"
                        eventKey="1"
                        onClick={() => {
                          const data = {
                            reqId: NormalizedData(
                              props?.RowData,
                              "requisitionid"
                            ),
                            status: NormalizedData(
                              props?.RowData,
                              "requisitionstatus"
                            ),
                            orderid: NormalizedData(
                              props?.RowData,
                              "requisitionorderid"
                            ),
                            recordid: NormalizedData(
                              props?.RowData,
                              "recordid"
                            ),
                            referenceId: NormalizedData(
                              props?.RowData,
                              "referenceid"
                            ),
                          };
                          navigate(`/requisition`, {
                            state: data,
                          });
                        }}
                      >
                        <div>
                          <i className="fa fa-edit text-warning mr-2 w-20px"></i>
                          {getPermissionDisplayName(
                            pageName,
                            moduleName,
                            permissionIdentifier,
                            "Edit"
                          )}
                        </div>
                      </Dropdown.Item>
                    )}
                  </PermissionComponent>
                  <PermissionComponent
                    moduleName="PGX LIS"
                    pageName="Interpretation"
                    permissionIdentifier="Reject"
                  >
                    {({ pageName, moduleName, permissionIdentifier }) => (
                      <Dropdown.Item
                        id="RequisitionDelete"
                        eventKey="3"
                        onClick={() => setShow(true)}
                      >
                        <button
                          role="link"
                          className="px-0 border-0 bg-transparent "
                        >
                          <i className="fa fa-trash text-danger mr-2 w-20px"></i>
                          {getPermissionDisplayName(
                            pageName,
                            moduleName,
                            permissionIdentifier,
                            "Reject"
                          )}
                        </button>
                      </Dropdown.Item>
                    )}
                  </PermissionComponent>
                  <PermissionComponent
                    moduleName="PGX LIS"
                    pageName="Interpretation"
                    permissionIdentifier="Rerun"
                  >
                    {({ pageName, moduleName, permissionIdentifier }) => (
                      <Dropdown.Item
                        id="RerunRecord"
                        eventKey="4"
                        onClick={() => rerunMutation.mutate()}
                      >
                        <button
                          role="link"
                          className="px-0 border-0 bg-transparent"
                        >
                          <i className="fa fa-arrow-rotate-right text-primary mr-2 w-20px"></i>
                          {getPermissionDisplayName(
                            pageName,
                            moduleName,
                            permissionIdentifier,
                            "Rerun"
                          )}
                        </button>
                      </Dropdown.Item>
                    )}
                  </PermissionComponent>
                </>
              ) : filterData.tabId === 2 ? (
                <>
                  <PermissionComponent
                    moduleName="PGX LIS"
                    pageName="Interpretation"
                    permissionIdentifier="Rerun"
                  >
                    {({ pageName, moduleName, permissionIdentifier }) => (
                      <Dropdown.Item
                        id="RerunRecord"
                        eventKey="4"
                        onClick={() => rerunMutation.mutate()}
                      >
                        <button
                          role="link"
                          className="px-0 border-0 bg-transparent"
                        >
                          <i className="fa fa-arrow-rotate-right text-primary mr-2 w-20px"></i>
                          {getPermissionDisplayName(
                            pageName,
                            moduleName,
                            permissionIdentifier,
                            "Rerun"
                          )}
                        </button>
                      </Dropdown.Item>
                    )}
                  </PermissionComponent>
                  <PermissionComponent
                    moduleName="PGX LIS"
                    pageName="Interpretation"
                    permissionIdentifier="Resend"
                  >
                    {({ pageName, moduleName, permissionIdentifier }) => (
                      <Dropdown.Item
                        id="ResendRecord"
                        eventKey="5"
                        onClick={() => resendMutation.mutate()}
                      >
                        <button
                          role="link"
                          className="px-0 border-0 bg-transparent"
                        >
                          <i className="fa fa-paper-plane text-info mr-2 w-20px"></i>
                          {getPermissionDisplayName(
                            pageName,
                            moduleName,
                            permissionIdentifier,
                            "Resend"
                          )}
                        </button>
                      </Dropdown.Item>
                    )}
                  </PermissionComponent>
                </>
              ) : (
                <>
                  <PermissionComponent
                    moduleName="PGX LIS"
                    pageName="Interpretation"
                    permissionIdentifier="View"
                  >
                    {({ pageName, moduleName, permissionIdentifier }) => (
                      <Dropdown.Item eventKey="2">
                        <button
                          id="ViewRequisitionView2"
                          role="link"
                          className="px-0 border-0 bg-transparent"
                          onClick={() => {
                            const tokenData: any =
                              sessionStorage.getItem("userinfo");
                            localStorage.setItem("userinfo", tokenData);
                            openInNewTab(
                              `/OrderView/${btoa(
                                NormalizedData(props?.RowData, "requisitionid")
                              )}/${btoa(
                                NormalizedData(
                                  props?.RowData,
                                  "requisitionorderid"
                                )
                              )}`
                            );
                          }}
                        >
                          <i className="fa fa-eye text-success mr-2 w-20px"></i>
                          {getPermissionDisplayName(
                            pageName,
                            moduleName,
                            permissionIdentifier,
                            "View"
                          )}
                        </button>
                      </Dropdown.Item>
                    )}
                  </PermissionComponent>
                  <PermissionComponent
                    moduleName="PGX LIS"
                    pageName="Interpretation"
                    permissionIdentifier="Restore"
                  >
                    {({ pageName, moduleName, permissionIdentifier }) => (
                      <Dropdown.Item
                        id="RequisitionDelete"
                        eventKey="3"
                        onClick={() =>
                          restoreRequisition(
                            NormalizedData(props?.RowData, "requisitionorderid")
                          )
                        }
                      >
                        <button
                          role="link"
                          className="px-0 border-0 bg-transparent "
                        >
                          <i className="fa-solid fa-arrow-rotate-right text-primary mr-2 w-20px"></i>
                          {getPermissionDisplayName(
                            pageName,
                            moduleName,
                            permissionIdentifier,
                            "Restore"
                          )}
                        </button>
                      </Dropdown.Item>
                    )}
                  </PermissionComponent>
                </>
              )}
            </DropdownButton>
          </div>
        </TableCell>
        {props?.tabsInfo &&
          props?.tabsInfo.map((tabData: any) => {
            return tabData.isShowOnUi &&
              !tabData.isExpandData &&
              tabData.isShow ? (
              <>
                {tabData?.columnKey?.toLowerCase() === "approve" ? (
                  <TableCell
                    id={`BloodResultDataReportCell_${NormalizedData(props?.RowData, "requisitionorderid")}`}
                    className="text-center"
                  >
                    <div className="d-flex justify-content-center">
                      {filterData.tabId === 1 || filterData.tabId === 3 ? (
                        <PermissionComponent
                          moduleName="PGX LIS"
                          pageName="Interpretation"
                          permissionIdentifier="Approve"
                        >
                          {({ pageName, moduleName, permissionIdentifier }) => (
                            <button
                              id={`BloodResultDataReportButton_${NormalizedData(props?.RowData, "requisitionorderid")}`}
                              className="btn btn-sm fw-bold btn-excle fs-12px py-0 fw-500 align-items-center d-flex text-white"
                              onClick={() => approveMutation.mutate()}
                              disabled={!props?.RowData.resultFile}
                            >
                              {getPermissionDisplayName(
                                pageName,
                                moduleName,
                                permissionIdentifier,
                                "Approve"
                              )}
                            </button>
                          )}
                        </PermissionComponent>
                      ) : (
                        <PermissionComponent
                          moduleName="PGX LIS"
                          pageName="Interpretation"
                          permissionIdentifier="Unapproved"
                        >
                          {({ pageName, moduleName, permissionIdentifier }) => (
                            <button
                              id={`BloodResultDataReportButton_${NormalizedData(props?.RowData, "requisitionorderid")}`}
                              className="btn btn-sm fw-bold btn-excle fs-12px py-0 fw-500 align-items-center d-flex text-white"
                              onClick={() => unApproveMutation.mutate()}
                            >
                              {getPermissionDisplayName(
                                pageName,
                                moduleName,
                                permissionIdentifier,
                                "Un-Approve"
                              )}
                            </button>
                          )}
                        </PermissionComponent>
                      )}
                    </div>
                  </TableCell>
                ) : tabData?.columnKey?.toLowerCase() === "printlabel" ? (
                  <TableCell>
                    <div style={{ width: "max-content" }}>
                      <StyledDropButton
                        id={`BloodResultDataPrintLabelButton_${NormalizedData(props?.RowData, "requisitionorderid")}`}
                        aria-controls={
                          openDrop ? "demo-positioned-menu4" : undefined
                        }
                        aria-haspopup="true"
                        aria-expanded={openDrop ? "true" : undefined}
                        onClick={(event) => handleClick(event, "dropdown4")}
                        className="btn btn-dark-brown btn-sm py-0 fw-400 fa-1x min-h-25px h-25px w-100px"
                      >
                        {t("Print Label")}
                        <span className="svg-icon svg-icon-5 m-0">
                          <ArrowBottomIcon />
                        </span>
                      </StyledDropButton>
                      <StyledDropMenu
                        id={`BloodResultDataPrintLabelMenu_${NormalizedData(props?.RowData, "requisitionorderid")}`}
                        aria-labelledby="demo-positioned-button4"
                        anchorEl={anchorEl.dropdown4}
                        open={Boolean(anchorEl.dropdown4)}
                        onClose={() => handleClose("dropdown4")}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        className="w-auto"
                      >
                        {data?.printersInfo?.map((option: any) => (
                          <MenuItem
                            onClick={() =>
                              PrintLabel(option?.label, option.value)
                            }
                            className="w-auto"
                            key={option.value}
                            value={option.value}
                          >
                            <i className="fa fa fa-print text-warning mr-2 w-20px"></i>
                            {option?.label}
                          </MenuItem>
                        ))}
                      </StyledDropMenu>
                    </div>
                  </TableCell>
                ) : props?.RowData?.[tabData?.columnKey]?.includes(
                    "https://truemedpo.blob.core.windows.net"
                  ) ||
                  props?.RowData?.[tabData?.columnKey]?.includes(
                    "https://digitalrequsitions.blob.core.windows.net"
                  ) ? (
                  <TableCell
                    id={`BloodResultDataDocsViewer_${NormalizedData(props?.RowData, "requisitionorderid")}`}
                  >
                    <div className="d-flex justify-content-center">
                      <Link to={`/docs-viewer`} target="_blank">
                        <i
                          className="bi bi-file-earmark-pdf text-danger fa-2x cursor-pointer"
                          onClick={() => {
                            dispatch(
                              savePdfUrls(props?.RowData?.[tabData?.columnKey])
                            );
                          }}
                        ></i>
                      </Link>
                    </div>
                  </TableCell>
                ) : tabData?.columnKey.toLowerCase() === "requisitionstatus" ? (
                  <TableCell
                    id={`BloodResultDataStatus1_${NormalizedData(props?.RowData, "requisitionorderid")}`}
                    sx={{ width: "max-content", textAlign: "center" }}
                  >
                    <Status
                      cusText={props?.RowData?.[tabData?.columnKey]}
                      cusClassName={
                        props?.RowData?.[tabData?.columnKey] ===
                        t("Specimen Collected")
                          ? "badge-status-specimen-collected"
                          : props?.RowData?.[tabData?.columnKey] ===
                              t("Processing")
                            ? "badge-status-processing"
                            : props?.RowData?.[tabData?.columnKey] ===
                                t("Result Available")
                              ? "badge-status-result-available"
                              : props?.RowData?.[tabData?.columnKey] ===
                                  t("Complete")
                                ? "badge-status-complete"
                                : props?.RowData?.[tabData?.columnKey] ===
                                    t("Deleted")
                                  ? "badge-status-deleted"
                                  : props?.RowData?.[tabData?.columnKey] ===
                                      t("Validated")
                                    ? "badge-status-validated"
                                    : props?.RowData?.[tabData?.columnKey] ===
                                        t("Save For Signature")
                                      ? "badge-status-waiting-for-Signature"
                                      : props?.RowData?.[tabData?.columnKey] ===
                                          t("On Hold")
                                        ? "badge-status-hold"
                                        : props?.RowData?.[
                                              tabData?.columnKey
                                            ] === t("Missing Info")
                                          ? "badge-status-missing-info"
                                          : props?.RowData?.[
                                                tabData?.columnKey
                                              ] === t("In Transit")
                                            ? "badge-status-in-transit"
                                            : props?.RowData?.[
                                                  tabData?.columnKey
                                                ] === t("Canceled")
                                              ? "badge-status-canceled"
                                              : props?.RowData?.[
                                                    tabData?.columnKey
                                                  ] === t("Approved")
                                                ? "badge-status-approved"
                                                : props?.RowData?.[
                                                      tabData?.columnKey
                                                    ] === t("Pending")
                                                  ? "badge-status-pending"
                                                  : props?.RowData?.[
                                                        tabData?.columnKey
                                                      ] === t("Rejected")
                                                    ? "badge-status-rejected"
                                                    : props?.RowData?.[
                                                          tabData?.columnKey
                                                        ] === t("Shipped")
                                                      ? "badge-status-shipped"
                                                      : "badge-status-default"
                      }
                    />
                  </TableCell>
                ) : tabData?.columnKey.toLowerCase() === "lisstatus" ? (
                  <TableCell
                    id={`BloodResultDataStatus2_${NormalizedData(props?.RowData, "requisitionorderid")}`}
                    sx={{ width: "max-content", textAlign: "center" }}
                  >
                    <Status
                      cusText={props?.RowData?.[tabData?.columnKey]}
                      cusClassName={
                        props?.RowData?.[tabData?.columnKey] ===
                        t("Ready to Report")
                          ? "badge-status-result-available"
                          : props?.RowData?.[tabData?.columnKey] ===
                              t("Amended")
                            ? "badge-status-complete"
                            : props?.RowData?.[tabData?.columnKey] ===
                                t("Ready to Validate")
                              ? "badge-status-validated"
                              : props?.RowData?.[tabData?.columnKey] ===
                                  t("Final")
                                ? "badge-status-hold"
                                : props?.RowData?.[tabData?.columnKey] ===
                                    t("Corrected")
                                  ? "badge-status-in-transit"
                                  : props?.RowData?.[tabData?.columnKey] ===
                                      t("Pending")
                                    ? "badge-status-pending"
                                    : props?.RowData?.[tabData?.columnKey] ===
                                        t("Ready to Publish")
                                      ? "badge-status-shipped"
                                      : "badge-status-default"
                      }
                    />
                  </TableCell>
                ) : (
                  <TableCell
                    id={`${tabData?.columnKey}_${NormalizedData(props?.RowData, "requisitionorderid")}`}
                  >
                    {formatViewRequisitionLabTime(
                      props?.RowData,
                      tabData?.columnKey,
                      isIntegrationOrder(props?.RowData)
                        ? undefined
                        : props?.labTimeZone
                    ) ??
                      dateFormatConversion(props?.RowData, tabData?.columnKey)}
                  </TableCell>
                )}
              </>
            ) : null;
          })}
      </TableRow>
    </>
  );
};

export default React.memo(Row);
